/**
 * Common - Cart items molecule.
 */

// Constants (ids)
const cartQuickLinkId = 'cartQuickLink';

// Named exports - Constants
export default cartQuickLinkId;



// WEBPACK FOOTER //
// ./js/common/molecule/cart-items.js